module.exports = __webpack_public_path__ + "img/line.f61f5482.svg";